import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import {
  FileEarmarkBarGraph as Icon_File,
} from "react-bootstrap-icons";

const SeleccionarProceso = () => {
  const navigate = useNavigate();
  const ticket = useSelector((state) => state.ticket);

  // Defensa en profundidad: solo admin institución (Retorno 2) o superusuario
  // (Retorno 3) pueden ver el selector. ProtectedRoute ya bloquea no-autenticados.
  if (!ticket || (ticket.Retorno != 2 && ticket.Retorno != 3)) {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <Container fluid="xl" className="mt-5">
      <Row className="mb-4">
        <Col className="text-center">
          <h3 className="xz-titulo1">Seleccionar Proceso</h3>
          <p className="text-secondary">
            Escoja el proceso cuyos resultados desea revisar.
          </p>
        </Col>
      </Row>

      <Row className="justify-content-center g-4">
        <Col md={5}>
          <Card className="h-100 shadow-sm">
            <Card.Body className="d-flex flex-column">
              <div className="d-flex align-items-center mb-3">
                <Icon_File size={28} className="me-2 text-secondary" />
                <Card.Title className="mb-0">
                  Proceso Diciembre 2025
                </Card.Title>
              </div>
              <Card.Subtitle className="mb-2 text-muted">
                Calibración — Cu4400
              </Card.Subtitle>
              <Card.Text className="text-secondary">
                Resultados del proceso de calibración inicial (04/12/2025).
                Esta vista permanece intacta como referencia histórica.
              </Card.Text>
              <div className="mt-auto">
                <Button
                  variant="outline-primary"
                  className="w-100 xz-btn-ok"
                  onClick={() => navigate("/reporte/251204")}
                >
                  Ver reporte 251204
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={5}>
          <Card className="h-100 shadow-sm">
            <Card.Body className="d-flex flex-column">
              <div className="d-flex align-items-center mb-3">
                <Icon_File size={28} className="me-2 text-primary" />
                <Card.Title className="mb-0">Proceso Mayo 2026</Card.Title>
              </div>
              <Card.Subtitle className="mb-2 text-muted">
                Producción
              </Card.Subtitle>
              <Card.Text className="text-secondary">
                Resultados del proceso productivo (21/05/2026). Datos cargados
                en vivo desde la base.
              </Card.Text>
              <div className="mt-auto">
                <Button
                  variant="primary"
                  className="w-100 xz-btn-ok"
                  onClick={() => navigate("/reporte/260521")}
                >
                  Ver reporte 260521
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SeleccionarProceso;
